import styled from 'styled-components';

import { Link } from '@dreryk/react-components';

export const StyledGoToNfzLink = styled(Link)`
   display: inline-block;
`;
